import { Button } from '@strata/react-buttons';
import { WarningDialog } from '@strata/react-dialog';
import { DetailLabel, DetailLabelValuePair } from '@strata/react-label-value-pairs';
import { ServicingRate } from '@strata/react-servicing-rate';
import { SuccessToast } from '@strata/react-toast-message';
import PropTypes from 'prop-types';

import { BackstopPharmacyStatusIndicator } from '../BackstopPharmacyStatusIndicator';

import { handleError } from 'services/ErrorManagement';
import { httpDelete } from 'services/Http';

export const DeleteBackstopPharmacyDialog = ({ backstopPharmacyToDelete = undefined, onClose }) => (
    <WarningDialog
        dialogTitle="Confirm Delete Post Live Referral Assignment"
        width={700}
        isOpen={!!backstopPharmacyToDelete}
        primaryButtonLabel="Yes, Delete Post Live Referral Assignment"
        primaryButtonIntent={Button.Intent.DANGER}
        onPrimaryButtonClick={async () => {
            try {
                await httpDelete(
                    `/assignment/backstop_pharmacies/delete/${backstopPharmacyToDelete?.backstop_pharmacy_id}`,
                );
                SuccessToast({ message: 'Post Live Referral Assignment successfully deleted.' });
                onClose();
            } catch (err) {
                handleError('Error deleting Post Live Referral Assignment', err);
            }
        }}
        secondaryButtonLabel="No, Cancel"
        onSecondaryButtonClick={onClose}
        dialogContent={
            <>
                <div className="margin__bottom--large">
                    Are you sure you want to delete the following Post Live Referral Assignment?
                </div>
                <div className="flex__gap--x-large">
                    <DetailLabelValuePair label="Drug" value={backstopPharmacyToDelete?.product} />
                    <DetailLabelValuePair
                        label="Benefit"
                        value={backstopPharmacyToDelete?.benefit}
                    />
                    <DetailLabelValuePair
                        label="Place Of Service"
                        value={backstopPharmacyToDelete?.placeOfService}
                    />
                    <DetailLabelValuePair
                        label="Pharmacy"
                        value={backstopPharmacyToDelete?.supplier}
                    />
                    <DetailLabelValuePair
                        label="Contract Rate"
                        value={
                            <ServicingRate
                                servicingRate={backstopPharmacyToDelete?.backstop_rate}
                                referentPriceType={backstopPharmacyToDelete?.referent_price_type}
                            />
                        }
                    />
                    <DetailLabelValuePair
                        label="Start Date"
                        value={backstopPharmacyToDelete?.backstop_start_date}
                    />
                    <DetailLabelValuePair
                        label="End Date"
                        value={backstopPharmacyToDelete?.backstop_end_date}
                    />
                    <div>
                        <DetailLabel label="Status" />
                        <BackstopPharmacyStatusIndicator
                            status={backstopPharmacyToDelete?.backstopStatus}
                        />
                    </div>
                </div>
            </>
        }
    />
);

DeleteBackstopPharmacyDialog.propTypes = {
    backstopPharmacyToDelete: PropTypes.shape({
        backstop_pharmacy_id: PropTypes.string.isRequired,
        product: PropTypes.string.isRequired,
        benefit: PropTypes.string.isRequired,
        placeOfService: PropTypes.string.isRequired,
        supplier: PropTypes.string.isRequired,
        backstop_rate: PropTypes.string.isRequired,
        referent_price_type: PropTypes.string.isRequired,
        backstop_start_date: PropTypes.string.isRequired,
        backstop_end_date: PropTypes.string,
        backstopStatus: PropTypes.string.isRequired,
    }),
    onClose: PropTypes.func.isRequired,
};
